import { css } from '@firebolt-dev/css'
import { useLayoutEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'

export const TOOLTIP_DELAY = 300 // ms — must match long-press threshold in InterfaceView

const TOOLTIP_W = 220
const MARGIN = 8
const GAP = 20

export function ItemTooltip({ item, cellRect }) {
  const tooltipRef = useRef(null)
  const [above, setAbove] = useState(null) // null = not yet measured

  useLayoutEffect(() => {
    if (tooltipRef.current) {
      const { height } = tooltipRef.current.getBoundingClientRect()
      setAbove(cellRect.top - GAP - height >= 0)
    }
  }, [item, cellRect])

  if (!item || !cellRect) return null

  const left = Math.max(MARGIN, Math.min(cellRect.left + cellRect.width / 2 - TOOLTIP_W / 2, window.innerWidth - TOOLTIP_W - MARGIN))
  const pos = {
    left,
    visibility: above === null ? 'hidden' : 'visible',
    ...(above === false
      ? { top: cellRect.bottom + GAP }
      : { bottom: window.innerHeight - cellRect.top + GAP }),
  }

  return createPortal(
    <div
      ref={tooltipRef}
      css={css`
        position: fixed;
        z-index: 1000;
        width: ${TOOLTIP_W}px;
        background: rgba(0, 0, 0, 0.85);
        border-radius: 8px;
        pointer-events: none;
        padding: 15px;
        display: flex;
        flex-direction: column;
        gap: 4px;
      `}
      style={pos}
    >
      <div
        css={css`
          font-size: 17px;
          font-weight: 700;
          color: white;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        `}
      >
        {item.name}
      </div>
      {item.description && (
        <div
          css={css`
            font-size: 16px;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.65);
            line-height: 1.2;
            white-space: normal;
          `}
        >
          {item.description}
        </div>
      )}
    </div>,
    document.body
  )
}
